import { callFunctionIfExists } from "utils/GeneralUtils";
import { useEffect } from "react";
import { Collapse } from "reactstrap";
import useToggle from "../../hooks/useToggle";

const SettingsGroup = ({
  title = "Settings",
  children,
  className,
  externalTrigger,
  closeExternalTrigger,
  disabled = false,
  disabledComponent,
  hidden = false,
}) => {
  const [open, toggleOpen] = useToggle();

  useEffect(() => {
    if (externalTrigger) {
      toggleOpen();
    }

    callFunctionIfExists(closeExternalTrigger);
  }, [externalTrigger, closeExternalTrigger, toggleOpen]);

  if (hidden) return null;

  return (
    <div
      className={`border rounded-sm mb-1 cursor-pointer ${className}`}
      style={{ width: "100%" }}
    >
      <div
        className="px-2 py-1 d-flex justify-content-between align-items-center bg-ultralight rounded-sm"
        onClick={toggleOpen}
      >
        <h5 className="m-0 p-0 text-dark">{title}</h5>
        <i className={`mdi mdi-chevron-${open ? "down" : "right"}`} />
      </div>
      <Collapse isOpen={open}>
        <div className="border-top p-2">
          {disabled ? disabledComponent : children}
        </div>
      </Collapse>
    </div>
  );
};

export default SettingsGroup;
